import { jsx as _jsx } from "react/jsx-runtime";
import { buildContext } from './buildContext';
export const [useEnvironmentConfiguration, EnvironmentContextProvider] = buildContext();
export const EnvironmentProvider = ({ countryCode, languageCode, isKiosk, storeId, children }) => {
    return (_jsx(EnvironmentContextProvider, { value: {
            locale: `${languageCode}-${countryCode}`,
            countryCode: countryCode,
            languageCode: languageCode,
            isKiosk: isKiosk,
            storeId: storeId
        }, children: children }));
};
export const useLocale = () => {
    const { locale } = useEnvironmentConfiguration();
    return locale;
};
export const useCountryCode = () => {
    const { countryCode } = useEnvironmentConfiguration();
    return countryCode;
};
export const useLanguageCode = () => {
    const { languageCode } = useEnvironmentConfiguration();
    return languageCode;
};
export const useIsKiosk = () => {
    const { isKiosk } = useEnvironmentConfiguration();
    return isKiosk;
};
export const usePresetStoreId = () => {
    const { storeId } = useEnvironmentConfiguration();
    return storeId;
};
//# sourceMappingURL=environment.js.map